"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteThemeDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.SiteThemeDefinition = (0, helpers_1.defineService)('viewer-core/viewer-service-site-theme');
//# sourceMappingURL=index.js.map